import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import './Upgrade.css';



const PACKS = [
  {
    key: 'starter', name: 'Starter', price: '$0.99',
    puzzles: '10 credits', description: 'Perfect for trying it out.',
    expiry: 'Credits never expire',
    checkoutUrl: 'https://puzzlegame.gumroad.com/l/fnntiw',
    features: ['10 credits — any game', 'All 5 game types', 'No subscription', 'Never expire'],
    highlight: false,
  },
  {
    key: 'value', name: 'Value Pack', price: '$5.99',
    puzzles: '100 credits', description: 'Best value for regular players.',
    expiry: 'Credits never expire',
    checkoutUrl: 'https://puzzlegame.gumroad.com/l/cjhxe',
    features: ['100 credits — any game', 'All 5 game types', '$0.06 per credit', 'Never expire'],
    highlight: true,
  },

];

export default function Upgrade() {
  const { user }  = useAuth();
  const navigate  = useNavigate();
  const [loading, setLoading] = useState(null);



  const handleCheckout = (pack) => {
    if (!user) { navigate('/register'); return; }
    setLoading(pack.key);
    const url = `${pack.checkoutUrl}?wanted=true&email=${encodeURIComponent(user.email)}`;
    window.open(url, '_blank');
    setLoading(null);
  };

  return (
    <div className="upgrade-page">
      <div className="upgrade-hero">
        <div className="upgrade-badge mono">⚡ PuzzleForge Credits</div>
        <h1 className="upgrade-title mono">Unlock More Puzzles</h1>
        <p className="upgrade-sub">Buy puzzle credits — use them any time, any game.<br/>No subscription required.</p>
      </div>

      <div className="upgrade-cards">
        {PACKS.map(pack => (
          <div key={pack.key} className={`upgrade-card-item ${pack.highlight ? 'featured' : ''}`}>
            {pack.highlight && <div className="upgrade-popular mono">Best Value</div>}
            <div className="upgrade-card-header">
              <h2 className="mono">{pack.name}</h2>
              <div className="upgrade-price">
                <span className="upgrade-price-amount mono">{pack.price}</span>
                {pack.key === 'pro' && <span className="upgrade-price-period mono">/mo</span>}
              </div>
              <div className="upgrade-puzzles mono">{pack.puzzles}</div>
              <p className="upgrade-desc">{pack.description}</p>
            </div>
            <ul className="upgrade-features">
              {pack.features.map((f, i) => <li key={i}>✦ {f}</li>)}
            </ul>
            <div className="upgrade-expiry mono">{pack.expiry}</div>
            <button
              className={`btn-checkout mono ${pack.highlight ? 'featured' : ''}`}
              onClick={() => handleCheckout(pack)}
              disabled={loading === pack.key}
            >
              {loading === pack.key ? 'Opening...' : `Get ${pack.name}`}
            </button>
          </div>
        ))}
      </div>

      <div className="upgrade-free-note">
        <p className="mono">Free tier: <strong>2 plays per game per day forever</strong>. Credits unlock more plays — never expire.</p>
      </div>

      <div className="upgrade-faq">
        <h2 className="mono">Common questions</h2>
        <div className="faq-item">
          <h3>Do credits expire?</h3>
          <p>Starter and Value pack credits never expire. Pro subscription renews monthly.</p>
        </div>
        <div className="faq-item">
          <h3>Can I mix game types?</h3>
          <p>Yes — credits work across all 5 games in any combination.</p>
        </div>
        <div className="faq-item">
          <h3>What is the daily limit?</h3>
          <p>Free: 2 plays/game/day. Credits: unlimited. Pro: unlimited.</p>
        </div>

      </div>

      <div className="upgrade-legal mono">
        <Link to="/terms">Terms</Link> · <Link to="/privacy">Privacy</Link> · <Link to="/refund">Refund Policy</Link>
        <br/>Payments processed securely by Gumroad
      </div>
    </div>
  );
}
